import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getNotifications, markAsReviewed } from './reducer'
import {
  selectNotificationsList,
  selectUnreadCount,
  selectHasUnreadNotifications,
  selectIsNotificationsLoading,
  selectNotificationsError,
  selectUnreadNotifications,
  selectReviewedNotifications,
} from './selectors'
import { GetNotificationsPayload, MarkAsReviewedPayload } from './types'

export const useNotifications = () => {
  const dispatch = useDispatch()
  const notifications = useSelector(selectNotificationsList)
  const unreadCount = useSelector(selectUnreadCount)
  const hasUnread = useSelector(selectHasUnreadNotifications)
  const isLoading = useSelector(selectIsNotificationsLoading)
  const error = useSelector(selectNotificationsError)
  const unreadNotifications = useSelector(selectUnreadNotifications)
  const reviewedNotifications = useSelector(selectReviewedNotifications)

  const fetchNotifications = useCallback(
    (payload: GetNotificationsPayload) => {
      dispatch(getNotifications(payload))
    },
    [dispatch]
  )

  const markNotificationAsReviewed = useCallback(
    (payload: MarkAsReviewedPayload) => {
      dispatch(markAsReviewed(payload))
    },
    [dispatch]
  )

  return {
    notifications,
    unreadCount,
    hasUnread,
    isLoading,
    error,
    unreadNotifications,
    reviewedNotifications,
    fetchNotifications,
    markNotificationAsReviewed,
  }
}
